// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk {
  display: flex;
  align-items: center;
  gap: 20px;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk .InviteStaffPage_date__CE7jX {
  display: flex;
  align-items: center;
  gap: 4px;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk .InviteStaffPage_date__CE7jX img,
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk .InviteStaffPage_date__CE7jX svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk .InviteStaffPage_date__CE7jX span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_dataGridWrp__RgreJ {
  padding: 0 24px;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_listToolbar__0VYic {
  margin-bottom: 12px;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_listToolbar__0VYic .InviteStaffPage_listToolbarRow__OhQz- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_listToolbar__0VYic .InviteStaffPage_listToolbarRow__OhQz- .InviteStaffPage_filteredChips__OYWja {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_listToolbar__0VYic .InviteStaffPage_listToolbarRow__OhQz- .InviteStaffPage_filteredChips__OYWja .InviteStaffPage_filteredChipsLabel__\\+Mrc0 {
  font: var(--body-font-four);
  font-weight: 600;
  color: var(--primary-Text);
  display: inline-block;
  margin-right: 8px;
}
.InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_listToolbar__0VYic .InviteStaffPage_listToolbarRow__OhQz- .InviteStaffPage_filterBtns__W0F8A {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
}

.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_csvAddMemberRow__bsiDN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
}
.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldWrp__VGKUx {
  max-height: 300px;
  overflow-y: auto;
}
.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}
.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding-top: 2px;
}
.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi .InviteStaffPage_input__G0r7M {
  width: 100%;
}
.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi .InviteStaffPage_role__59Aza {
  min-width: 170px;
}
.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi .InviteStaffPage_deleteBtn__5DI\\+J {
  width: 40px;
  height: 40px;
}
.InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi .InviteStaffPage_deleteBtn__5DI\\+J button {
  padding: 10px;
}

@media (max-width: 767px) {
  .InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh {
    padding: 16px;
  }
  .InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk {
    gap: 12px;
  }
  .InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_dataGridWrp__RgreJ {
    padding: 0 16px;
  }
  .InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_csvAddMemberRow__bsiDN button {
    font-size: 12px !important;
  }
}
@media (max-width: 600px) {
  .InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi {
    flex-wrap: wrap;
  }
  .InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi .InviteStaffPage_role__59Aza {
    order: 3;
    width: 100%;
  }
  .InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi .InviteStaffPage_deleteBtn__5DI\\+J {
    width: 35px;
    height: 35px;
    flex-shrink: 0;
  }
  .InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_addMemberFieldRow__OSMHB .InviteStaffPage_row__Uckzi .InviteStaffPage_deleteBtn__5DI\\+J button {
    min-height: auto;
    width: 100%;
    padding: 2px;
    height: 100%;
  }
  .InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_row__Uckzi > div:first-child {
    flex: 1 1;
  }
  .InviteStaffPage_InviteModalInner__BnTFu .InviteStaffPage_row__Uckzi > div:first-child .InviteStaffPage_input__G0r7M {
    max-width: 100%;
  }
}
@media (max-width: 425px) {
  .InviteStaffPage_staffPageWrp__Va7XK .InviteStaffPage_staffHeader__XhSNh .InviteStaffPage_right__2pihk .InviteStaffPage_date__CE7jX span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/inviteStaff/InviteStaffPage.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;AAUC;EACC,eAAA;AARF;AAWC;EACC,mBAAA;AATF;AAWE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AATH;AAWG;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AATJ;AAWI;EACC,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,iBAAA;AATL;AAaG;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AAXJ;;AAkBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAfF;AAkBC;EACC,iBAAA;EACA,gBAAA;AAhBF;AAmBC;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAjBF;AAmBE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAjBH;AAmBG;EACC,WAAA;AAjBJ;AAoBG;EACC,gBAAA;AAlBJ;AAqBG;EACC,WAAA;EACA,YAAA;AAnBJ;AAqBI;EACC,aAAA;AAnBL;;AA0BA;EAEE;IACC,aAAA;EAxBD;EA0BC;IACC,SAAA;EAxBF;EA0BE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAxBH;EA6BA;IACC,eAAA;EA3BD;EAiCC;IACC,0BAAA;EA/BF;AACF;AAoCA;EAGG;IACC,eAAA;EApCF;EAsCE;IACC,QAAA;IACA,WAAA;EApCH;EAuCE;IACC,WAAA;IACA,YAAA;IACA,cAAA;EArCH;EAuCG;IACC,gBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EArCJ;EA2CA;IACC,SAAA;EAzCD;EA2CC;IACC,eAAA;EAzCF;AACF;AA8CA;EAKK;IACC,aAAA;EAhDJ;AACF","sourcesContent":[".staffPageWrp {\r\n\t.staffHeader {\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\t\tgap: 15px;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.inviteBtn {}\r\n\t\t}\r\n\t}\r\n\r\n\t.dataGridWrp {\r\n\t\tpadding: 0 24px;\r\n\t}\r\n\r\n\t.listToolbar {\r\n\t\tmargin-bottom: 12px;\r\n\r\n\t\t.listToolbarRow {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\tgap: 10px;\r\n\r\n\t\t\t.filteredChips {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t.filteredChipsLabel {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\tmargin-right: 8px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.filterBtns {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tflex: 1;\r\n\t\t\t\tjustify-content: flex-end;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.InviteModalInner {\r\n\t.csvAddMemberRow {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\r\n\t.addMemberFieldWrp {\r\n\t\tmax-height: 300px;\r\n\t\toverflow-y: auto;\r\n\t}\r\n\r\n\t.addMemberFieldRow {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 15px;\r\n\t\tmargin-bottom: 15px;\r\n\t\twidth: 100%;\r\n\r\n\t\t.row {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: 100%;\r\n\t\t\tpadding-top: 2px;\r\n\r\n\t\t\t.input {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t.role {\r\n\t\t\t\tmin-width: 170px;\r\n\t\t\t}\r\n\r\n\t\t\t.deleteBtn {\r\n\t\t\t\twidth: 40px;\r\n\t\t\t\theight: 40px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tpadding: 10px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.staffPageWrp {\r\n\t\t.staffHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.dataGridWrp {\r\n\t\t\tpadding: 0 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t.InviteModalInner {\r\n\t\t.csvAddMemberRow {\r\n\t\t\tbutton {\r\n\t\t\t\tfont-size: 12px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 600px) {\r\n\t.InviteModalInner {\r\n\t\t.addMemberFieldRow {\r\n\t\t\t.row {\r\n\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t.role {\r\n\t\t\t\t\torder: 3;\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.deleteBtn {\r\n\t\t\t\t\twidth: 35px;\r\n\t\t\t\t\theight: 35px;\r\n\t\t\t\t\tflex-shrink: 0;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\tmin-height: auto;\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\tpadding: 2px;\r\n\t\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.row>div:first-child {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.staffPageWrp {\r\n\t\t.staffHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"staffPageWrp": `InviteStaffPage_staffPageWrp__Va7XK`,
	"staffHeader": `InviteStaffPage_staffHeader__XhSNh`,
	"right": `InviteStaffPage_right__2pihk`,
	"date": `InviteStaffPage_date__CE7jX`,
	"dataGridWrp": `InviteStaffPage_dataGridWrp__RgreJ`,
	"listToolbar": `InviteStaffPage_listToolbar__0VYic`,
	"listToolbarRow": `InviteStaffPage_listToolbarRow__OhQz-`,
	"filteredChips": `InviteStaffPage_filteredChips__OYWja`,
	"filteredChipsLabel": `InviteStaffPage_filteredChipsLabel__+Mrc0`,
	"filterBtns": `InviteStaffPage_filterBtns__W0F8A`,
	"InviteModalInner": `InviteStaffPage_InviteModalInner__BnTFu`,
	"csvAddMemberRow": `InviteStaffPage_csvAddMemberRow__bsiDN`,
	"addMemberFieldWrp": `InviteStaffPage_addMemberFieldWrp__VGKUx`,
	"addMemberFieldRow": `InviteStaffPage_addMemberFieldRow__OSMHB`,
	"row": `InviteStaffPage_row__Uckzi`,
	"input": `InviteStaffPage_input__G0r7M`,
	"role": `InviteStaffPage_role__59Aza`,
	"deleteBtn": `InviteStaffPage_deleteBtn__5DI+J`
};
export default ___CSS_LOADER_EXPORT___;
